import { RefObject, useContext } from 'react';
import { WorkflowScrollContext } from './workflow-scroll.context';

export const useWorkflowScrollContext = (): RefObject<HTMLElement> => {
  const overlayRef = useContext(WorkflowScrollContext);
  if (!overlayRef) {
    throw new Error('useWorkflowScrollContext must be used within WorkflowScrollContext.Provider');
  }
  return overlayRef;
};
